import React from "react";
import "./style.css";

const Fees = () => {
  return (
    <>
      {/* ===== Fees Banner Section ===== */}
      <section className="fees-banner">
        <div className="fees-overlay">
          <div className="fees-content container">
            <h1 className="fees-title">Fees</h1>
            <p className="fees-breadcrumb">
              Home <span className="arrow">→</span> Fees
            </p>
          </div>
        </div>
      </section>

      {/* ===== Fees Intro Section ===== */}
      <section className="fees-intro">
        <div className="container text-center">
          <p className="fees-subtitle">
            We Promise Low Fees and No Extra Charges
          </p>
          <h2 className="fees-heading">
            Built for Business Owners, <br /> Entrepreneurs and Freelancers
          </h2>
          <p className="fees-description">
            Omeswara Gateway delivers one of the most competitive pricing
            structures in the industry—simple, transparent, scalable, and
            reliable. Whether you're a startup or a growing enterprise,
            upgrading your business with Omeswara is effortless and can be done
            in just a few minutes.
          </p>
        </div>
      </section>

      {/* ===== Fees Pricing Section ===== */}
      <section className="fees-pricing-section">
        <div className="container pricing-container">
          {/* Left Section */}
          <div className="pricing-left">
            <h5 className="pricing-badge">Simple & Best Pricing</h5>
            <h2 className="pricing-title">Payment Modes</h2>

            <button className="signup-btn">Sign up Now</button>

            <ul className="payment-list">
              <li>UPI ✓</li>
              <li>QR/Intent ✓</li>
              <li>Credit Card ✓</li>
              <li>Debit Card ✓</li>
              <li>Net Banking ✓</li>
              <li>Wallet ✓</li>
              <li>No Setup Fees Required ✓</li>
              <li>No Additional Monthly Charges ✓</li>
              <li>Accept payments on your website ✓</li>
              <li>API for BBPS, AEPS, DMT & Micro ATM ✓</li>
              <li>Priority 24/7 support ✓</li>
            </ul>
          </div>

          {/* Right Section */}
          <div className="pricing-right">
            <h3 className="pricing-heading">
              Omeswar Will Make You Save More With Every Transaction
            </h3>

            <div className="pricing-grid">
              <div className="pricing-card">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/891/891462.png"
                  alt="Best Rate"
                  className="pricing-icon"
                />
                <h4>Best Rate</h4>
                <p>
                  We offer highly competitive pricing across all payment
                  modes—helping you keep more of your earnings.
                </p>
              </div>

              <div className="pricing-card">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/3063/3063828.png"
                  alt="Faster API"
                  className="pricing-icon"
                />
                <h4>Faster API Response</h4>
                <p>
                  Omeswara’s API is optimized for speed, delivering
                  lightning-fast responses for smoother customer payments.
                </p>
              </div>

              <div className="pricing-card">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/3534/3534063.png"
                  alt="Payment Channels"
                  className="pricing-icon"
                />
                <h4>Multiple Payment Channels</h4>
                <p>
                  Offer more ways for customers to pay with a unified platform
                  designed for seamless transactions.
                </p>
              </div>

              <div className="pricing-card">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/1019/1019607.png"
                  alt="Support"
                  className="pricing-icon"
                />
                <h4>24×7 Dedicated Support</h4>
                <p>
                  Our support team is always available to resolve queries
                  quickly and ensure uninterrupted business operations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Fees;
